export const DS = {
  colors: {
    shell: "#060b16",
    panel: "#0f1727",
    panelSoft: "#121d31",
    stroke: "rgba(255,255,255,0.14)",
    text: "#ebf1ff",
    textSoft: "#becbe2",
    brand: "#e6b15a",
    brandBlue: "#3e82ff",
    brandPurple: "#8b7cff",
    brandGreen: "#2ac37a",
    brandOrange: "#f08a3c",
    success: "#22C55E",
    danger: "#EF4444"
  },
  radius: {
    sm: 10,
    md: 12,
    lg: 16,
    pill: 999
  },
  spacing: {
    xxs: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24
  },
  type: {
    family: "'DM Sans', system-ui, sans-serif",
    label: { fontSize: 11, fontWeight: 700, letterSpacing: 1.2 },
    body: { fontSize: 15, fontWeight: 500, lineHeight: 1.62 },
    title: { fontSize: 20, fontWeight: 700, lineHeight: 1.22 },
    hero: { fontSize: 32, fontWeight: 700, lineHeight: 1.08 }
  },
  shadow: {
    card: "0 16px 34px rgba(1, 6, 18, 0.58)",
    glow: "0 0 0 1px rgba(243,169,82,0.2), 0 8px 24px rgba(62,130,255,0.2)"
  },
  gradients: {
    appBg: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180' viewBox='0 0 180 180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.78' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23n)' opacity='.15'/%3E%3C/svg%3E\"), linear-gradient(128deg, rgba(230,177,90,0.10) 0%, rgba(230,177,90,0.02) 26%, transparent 52%), linear-gradient(205deg, rgba(62,130,255,0.12) 0%, rgba(42,195,122,0.05) 38%, transparent 70%), linear-gradient(180deg, #070b14 0%, #0b1220 42%, #09101d 100%)",
    mosaic: "linear-gradient(130deg, #f3a952 0%, #f08a3c 42%, #3e82ff 100%)",
    cardEdge: "linear-gradient(120deg, rgba(243,169,82,0.45), rgba(62,130,255,0.35), rgba(139,124,255,0.3))"
  }
};

export const cardStyle = {
  background: DS.colors.panel,
  border: `1px solid ${DS.colors.stroke}`,
  borderRadius: DS.radius.lg,
  boxShadow: DS.shadow.card
};

export const buttonStyles = {
  primary: {
    background: DS.colors.brand,
    color: "#1a140a",
    border: "1px solid rgba(255,255,255,0.24)",
    boxShadow: "0 10px 20px rgba(230,177,90,0.24)"
  },
  subtle: {
    background: "#1c2639",
    color: DS.colors.text,
    border: `1px solid ${DS.colors.stroke}`,
    boxShadow: "0 6px 14px rgba(2,8,20,0.35)"
  },
  info: {
    background: DS.colors.brandBlue,
    color: "#fff",
    border: `1px solid rgba(255,255,255,0.18)`,
    boxShadow: "0 10px 18px rgba(62,130,255,0.22)"
  },
  success: {
    background: DS.colors.brandGreen,
    color: "#fff",
    border: `1px solid rgba(255,255,255,0.18)`,
    boxShadow: "0 10px 18px rgba(42,195,122,0.2)"
  }
};

export const buttonBase = {
  padding: "11px 14px",
  borderRadius: 12,
  minHeight: 44,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.25,
  width: "100%"
};

// UI: mapeamento enxuto de tokens usado pelas telas (screens/). Vive aqui
// (e nao dentro de PrototypeApp.js) para que qualquer componente de tela
// extraido do monolito possa importar sem depender do arquivo principal.
export const UI = {
  shell: DS.colors.shell,
  panel: DS.colors.panel,
  panelSoft: DS.colors.panelSoft,
  stroke: DS.colors.stroke,
  text: DS.colors.text,
  textSoft: DS.colors.textSoft,
  brand: DS.colors.brand,
  brandBlue: DS.colors.brandBlue,
  brandPurple: DS.colors.brandPurple,
  radiusLg: DS.radius.lg,
  radiusMd: DS.radius.md,
  radiusSm: DS.radius.sm,
  shadow: DS.shadow.card
};

